import { render, staticRenderFns } from "./preguntasFaq.vue?vue&type=template&id=709e024c"
import script from "./preguntasFaq.vue?vue&type=script&lang=js"
export * from "./preguntasFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports